export default __webpack_public_path__ + "static/media/bg-history-list_pc.a1c00f0e.png";